import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { fetchBillingNoteTemplates } from '../api/FetchBillingNoteTemplates';

export function useBillingNoteTemplates() {
  const { i18n } = useTranslation();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['billing-note-templates', i18n.language],
    queryFn: fetchBillingNoteTemplates,
    staleTime: Infinity,
  });

  return { templates: data ?? [], isLoading, isError, refetch };
}
